// extracted by mini-css-extract-plugin
export default {"promotion":"Promotion_promotion__mbJaK"};